module.exports = __webpack_public_path__ + "static/media/stripe.ca947fb1.png";